import React, { useState, useCallback, useContext } from 'react'
import CMSActions from './CMSActions'

const INITIAL_STATE = {
  section: 'department-info',
  fireDepartment: null,
  iarMember: null,
  sectionTitle: '',
  sectionId: '',
  sectionOrder: 0,
  socket: null,
  newsDisable: [],
  disableCMSOptions: true,
  disableCMSOptionsFull: false,
  departmentTimeBalance: null,
  appConfiguration: null,
  isReadOnlyMember: false,
  isMcsEnabled: false,
  isMarketing: false,
  isDemoDepartments: null,
  newVideoEncoding: null,
  isCustomSectionBeingSaved: false
}

const CMSContext = React.createContext(INITIAL_STATE)

function CMSProvider({ children }) {
  const [state, setState] = useState(INITIAL_STATE)

  const setSection = useCallback((newValue = true) => {
    setState((state) => ({
      ...state,
      section: newValue
    }))
  }, [])

  const setIsCustomSectionBeingSaved = useCallback((newValue = true) => {
    setState((state) => ({
      ...state,
      isCustomSectionBeingSaved: newValue
    }))
  }, [])

  const setFireDepartment = useCallback((newFireDepartment = {}) => {
    setState((state) => ({
      ...state,
      fireDepartment: newFireDepartment
    }))
  }, [])

  const setIarMember = useCallback((newIarMember = {}) => {
    setState((state) => ({
      ...state,
      iarMember: newIarMember
    }))
  }, [])
  const setEntities = useCallback((entities = {}) => {
    setState((state) => ({
      ...state,
      iarMember: entities.newIarMember,
      fireDepartment: entities.newFireDepartment
    }))
  }, [])

  const setSectionTitle = useCallback((newValue = true) => {
    setState((state) => ({
      ...state,
      sectionTitle: newValue
    }))
  }, [])

  const setNewVideoEncoding = useCallback((newValue = false) => {
    setState((state) => ({
      ...state,
      newVideoEncoding: newValue
    }))
  }, [])

  const setSectionId = useCallback((newValue = true) => {
    setState((state) => ({
      ...state,
      sectionId: newValue
    }))
  }, [])

  const setSectionOrder = useCallback((newValue = true) => {
    setState((state) => ({
      ...state,
      sectionOrder: newValue
    }))
  }, [])

  const setSocket = useCallback((newSocket = {}) => {
    setState((state) => ({
      ...state,
      socket: newSocket
    }))
  }, [])

  const setNewsDisable = useCallback((newValue = []) => {
    setState((state) => ({
      ...state,
      newsDisable: newValue
    }))
  }, [])
  const setIsReadOnlyMember = useCallback((newValue = []) => {
    setState((state) => ({
      ...state,
      isReadOnlyMember: newValue
    }))
  }, [])
  const setDisableCMSOptions = useCallback((newValue) => {
    setState((state) => ({
      ...state,
      disableCMSOptions: newValue,
      disableCMSOptionsFull: true
    }))
  }, [])

  const setDepartmentTimeBalance = useCallback((newDepartmentTimeBalance = {}) => {
    setState((state) => ({
      ...state,
      departmentTimeBalance: newDepartmentTimeBalance
    }))
  }, [])

  const setAppConfiguration = useCallback((newAppConfiguration = {}) => {
    setState((state) => ({
      ...state,
      appConfiguration: newAppConfiguration
    }))
  }, [])

  const setIsMarketing = useCallback((newIsMarketing = {}) => {
    setState((state) => ({
      ...state,
      isMarketing: newIsMarketing
    }))
  }, [])

  const setIsMcsEnabled =  useCallback((newIsMcsEnabled = {}) => {
    setState((state) => ({
      ...state,
      isMcsEnabled: newIsMcsEnabled
    }))
  }, [])

  const setIsDemoDepartments = useCallback((boolean = false) => {
    setState((state) => ({
      ...state,
      isDemoDepartments: boolean
    }))
  }, [])

  return (
    <CMSContext.Provider
      value={{
        state,
        actions: {
          setSection,
          setFireDepartment,
          setIarMember,
          setEntities,
          setSectionId,
          setSectionTitle,
          setSectionOrder,
          setSocket,
          setNewsDisable,
          setDisableCMSOptions,
          setDepartmentTimeBalance,
          setAppConfiguration,
          setIsReadOnlyMember,
          setIsMcsEnabled,
          setIsMarketing,
          setIsDemoDepartments,
          setNewVideoEncoding,
          setIsCustomSectionBeingSaved
        }
      }}
    >
      {children}
    </CMSContext.Provider>
  )
}

export function useCMSContext() {
  const { state, actions } = useContext(CMSContext)
  return { state, actions }
}

export default CMSProvider
